/* ============================================================
 * miyagen-raffle-cart.js — 抽選商品は単独購入のみ（合わせ買い不可）
 *
 * 理由（正しさ）: 抽選注文(_raffle)と通常商品が同一注文に混在すると、
 *   Worker が注文全体を raffle-hold（与信保持）し、同注文の通常商品まで
 *   capture されず宙ぶらりんになる。よって抽選商品は単独購入のみ許可する。
 *
 * 挙動:
 *   - 抽選商品ページ: カートに通常商品があれば ATC ボタン無効化＋警告
 *   - 通常商品ページ: カートに抽選商品があれば ATC ボタン無効化＋警告
 *   - カートページ:   抽選＋通常 混在ならチェックアウト無効化＋警告
 *
 * 判定: line item properties._raffle === 'true'（/cart.js）。
 *   抽選商品フォームには properties[_raffle]=true の hidden input（buy-buttons.liquid）。
 *
 * 安全性: 抽選商品が一切絡まない通常ショッピングでは常に no-op（誤ブロックしない）。
 * 注意: クライアント側ガード（バイパス可能）。最終防御は別途 Checkout 検証を検討。
 * ============================================================ */
(function () {
  'use strict';

  var MSG = '抽選商品は単独でのみご購入いただけます（他の商品との同時購入はできません）。お手数ですがカートを分けてご注文ください。';
  var lastCart = null;

  function isRelevantPage() {
    return !!document.querySelector(
      'form[action*="/cart/add"], cart-items, form[action="/cart"], [data-cart-items], #main-cart-items'
    );
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function counts(cart) {
    var raffle = 0, normal = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      var p = it.properties || {};
      if (String(p._raffle) === 'true') raffle += it.quantity; else normal += it.quantity;
    });
    return { raffle: raffle, normal: normal };
  }

  function pageIsRaffle() {
    return !!document.querySelector('form[action*="/cart/add"] input[name="properties[_raffle]"]');
  }

  function atcButtons() {
    return [].slice.call(
      document.querySelectorAll('form[action*="/cart/add"] [type="submit"], product-form button[type="submit"]')
    );
  }

  // 注意・ブロック通知（サイズ/トーンは miyagen-custom.css の .miyagen-raffle-warn = 予約と統一）
  function noticeBefore(el, id, show, message) {
    var note = document.getElementById(id);
    if (show) {
      if (!note && el && el.parentNode) {
        note = document.createElement('div');
        note.id = id;
        note.className = 'miyagen-raffle-warn';
        note.setAttribute('role', 'alert');
        el.parentNode.insertBefore(note, el);
      }
      if (note) note.textContent = message || MSG;
    } else if (note) {
      note.remove();
    }
  }

  var APPLIED_MSG = 'すでにこの抽選にご応募済みです（カートに入っています）。抽選は1点のみご応募いただけます。';

  function applyProductPage(cart) {
    var btns = atcButtons();
    if (!btns.length) return;
    var c = counts(cart);
    var raffle = pageIsRaffle();
    // 抽選ページ: すでに抽選品がカートにある→応募済み（二重応募/二個入りを根本防止）。通常品があれば単独購入違反。
    // 通常ページ: 抽選品がカートにある→単独購入違反。
    var block = false, msg = MSG;
    if (raffle) {
      if (c.raffle > 0) { block = true; msg = APPLIED_MSG; }
      else if (c.normal > 0) { block = true; msg = MSG; }
    } else if (c.raffle > 0) {
      block = true; msg = MSG;
    }
    btns.forEach(function (b) {
      if (block) {
        b.dataset.miyagenRaffleBlocked = '1';
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('aria-disabled', 'true');
      } else if (b.dataset.miyagenRaffleBlocked) {
        delete b.dataset.miyagenRaffleBlocked;
        b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
      }
    });
    // 追従(sticky)ATCバーはブロック時にバーごと非表示（「カートに追加」のまま押せて無反応＝紛らわしいのを防ぐ）。
    // 非ブロック時は inline を外し、本来の IntersectionObserver(.is-visible) に制御を戻す。
    var stickyBar = document.getElementById('StickyAddToCart');
    if (stickyBar) stickyBar.style.display = block ? 'none' : '';
    noticeBefore(btns[0], 'miyagen-raffle-block-note', block, msg);
  }

  function escTxt(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

  // Rise流にカートセクションを差し替え（混在解消後の再描画）。失敗時は reload。
  function rerenderCart(state) {
    if (!state || !state.sections) { location.reload(); return; }
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && state.sections['cart-drawer']) {
        var inner = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        var cur = drawer.querySelector('.drawer__inner');
        if (inner && cur) { cur.innerHTML = inner.innerHTML; return; }
      }
      var main = document.getElementById('main-cart-items');
      if (main && state.sections['main-cart-items']) {
        var fresh = new DOMParser().parseFromString(state.sections['main-cart-items'], 'text/html').querySelector('#main-cart-items');
        if (fresh) { main.innerHTML = fresh.innerHTML; return; }
      }
    } catch (e) {}
    location.reload();
  }

  // 指定 line(key) を削除し、最後の change で sections を取得して再描画
  function removeCartItems(keys) {
    if (!keys || !keys.length) return;
    var sectionList = document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'main-cart-items,cart-icon-bubble';
    var seq = Promise.resolve(null);
    keys.forEach(function (k, i) {
      seq = seq.then(function () {
        var payload = { id: k, quantity: 0 };
        if (i === keys.length - 1) { payload.sections = sectionList; payload.sections_url = window.location.pathname; }
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(payload) }).then(function (r) { return r.json(); });
      });
    });
    seq.then(function (state) { rerenderCart(state); refresh(); document.dispatchEvent(new CustomEvent('cart:updated')); }).catch(function () { location.reload(); });
  }

  // 混在カートの解決UI（どれが抽選応募/通常品か明示＋ワンクリックで片方を残す）
  function buildMixedWarning(cart) {
    var raffleItems = [], normalItems = [];
    (cart.items || []).forEach(function (it) {
      if (String((it.properties || {})._raffle) === 'true') raffleItems.push(it); else normalItems.push(it);
    });
    var rNames = raffleItems.map(function (it) { return it.product_title || it.title; }).join('、');
    var nNames = normalItems.map(function (it) { return it.product_title || it.title; }).join('、');
    var w = document.createElement('div');
    w.id = 'miyagen-raffle-cart-note';
    w.className = 'miyagen-raffle-warn';
    w.setAttribute('role', 'alert');
    w.innerHTML =
      '<strong>抽選応募と通常商品が同じカートに入っています。</strong>抽選応募は単独でのご注文が必要です（同時購入はできません）。どちらかに分けてください。'
      + '<div class="miyagen-raffle-warn__lines">'
      + '<div><span class="miyagen-raffle-warn__tag">抽選応募</span>' + escTxt(rNames) + '</div>'
      + '<div><span class="miyagen-raffle-warn__tag is-normal">通常商品</span>' + escTxt(nNames) + '</div>'
      + '</div>'
      + '<div class="miyagen-raffle-warn__btns">'
      + '<button type="button" data-keep="raffle">抽選応募だけ残す（通常商品を削除）</button>'
      + '<button type="button" data-keep="normal">通常商品だけ残す（応募を削除）</button>'
      + '</div>';
    w.querySelector('[data-keep="raffle"]').addEventListener('click', function () {
      this.disabled = true; removeCartItems(normalItems.map(function (it) { return it.key; }));
    });
    w.querySelector('[data-keep="normal"]').addEventListener('click', function () {
      this.disabled = true; removeCartItems(raffleItems.map(function (it) { return it.key; }));
    });
    return w;
  }

  function applyCartPage(cart) {
    if (!document.querySelector('cart-items, form[action="/cart"], [data-cart-items], #main-cart-items')) return;
    var c = counts(cart);
    var mixed = c.raffle > 0 && c.normal > 0;
    var checkoutBtns = [].slice.call(
      document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout-button, #checkout')
    );
    checkoutBtns.forEach(function (b) {
      if (mixed) {
        b.dataset.miyagenRaffleBlocked = '1';
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('aria-disabled', 'true');
      } else if (b.dataset.miyagenRaffleBlocked) {
        delete b.dataset.miyagenRaffleBlocked;
        b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
      }
    });
    var old = document.getElementById('miyagen-raffle-cart-note');
    if (old) old.remove();
    if (mixed) {
      var anchor = document.querySelector('cart-drawer .drawer__inner, #CartDrawer .drawer__inner') || document.querySelector('#main-cart-items, cart-items, form[action="/cart"]');
      if (anchor) anchor.insertBefore(buildMixedWarning(cart), anchor.firstChild);
    }
  }

  var MAX_RAFFLE_QTY = 1; // 抽選は1人1口=1点まで

  var INCART = 'cart-drawer, #CartDrawer, cart-items, #main-cart-items, .drawer__inner';

  // 商品ページの数量を1に固定（Riseの数量入力はフォーム外・form属性で紐付く。カート内の数量は触らない）
  function lockProductQty() {
    if (!pageIsRaffle()) return;
    document.querySelectorAll('quantity-input input[name="quantity"], input.quantity__input[name="quantity"]').forEach(function (q) {
      if (q.closest(INCART)) return;
      q.value = 1; q.setAttribute('max', '1'); q.setAttribute('min', '1'); q.readOnly = true;
    });
    document.querySelectorAll('quantity-input .quantity__button, .product-form__quantity .quantity__button').forEach(function (b) {
      if (b.closest(INCART)) return;
      b.setAttribute('disabled', 'disabled'); b.classList.add('disabled');
      b.style.opacity = '.35'; b.style.cursor = 'default'; b.style.pointerEvents = 'none';
    });
  }

  function fixRaffleQty(cart) {
    var over = (cart.items || []).filter(function (it) { return String((it.properties || {})._raffle) === 'true' && it.quantity > MAX_RAFFLE_QTY; })[0];
    if (!over) return false;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: over.key, quantity: MAX_RAFFLE_QTY }) })
      .then(function () { refresh(); }).catch(function () {});
    return true;
  }

  // 抽選応募のカート通知/バッジはサーバーレンダリング（miyagen-raffle-cart-notice /
  // miyagen-raffle-cart-item-badge）に統一。JS では挿入しない（予約販売と同じ構造）。

  function apply() {
    if (!lastCart) return;
    applyProductPage(lastCart);
    applyCartPage(lastCart);
    lockProductQty();
  }

  function refresh() {
    if (!isRelevantPage()) return;
    fetchCart()
      .then(function (cart) { lastCart = cart; if (fixRaffleQty(cart)) return; apply(); })
      .catch(function () {});
  }

  // ============================================================
  // 抽選応募 = 単独で即チェックアウト（カートを経由しない）。
  //   既存カートの通常商品は localStorage に退避 → 応募後にストアへ戻ったら自動復元。
  //   標準 /checkout 経由なので _raffle property は確実に注文へ届く（Workerが与信保持）。
  // ============================================================
  var PARK_KEY = 'miyagen_raffle_parked';
  var PARK_LOCK_KEY = 'miyagen_raffle_parked_lock';
  var PARK_LOCK_MS = 30 * 1000; // 復元処理中の二重実行を防ぐ猶予

  function parkClear() {
    try { localStorage.removeItem(PARK_KEY); } catch (e) {}
    try { localStorage.removeItem(PARK_LOCK_KEY); } catch (e) {}
  }

  // /cart/*.js は HTTP 422(売切れ等)/429/5xx でも fetch を reject しない。
  // response.ok を見ないと「追加できていないのに成功扱い」になり、空カートで /checkout へ進む。
  function cartWrite(url, payload) {
    var opt = { method: 'POST', credentials: 'same-origin' };
    if (payload) { opt.headers = { 'Content-Type': 'application/json' }; opt.body = JSON.stringify(payload); }
    return fetch(url, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (r.ok) return body;
        var desc = body && (body.description || body.message);
        var err = new Error(desc || (url + ' failed ' + r.status));
        err.cartStatus = r.status;
        if (desc) err.userMessage = desc;
        throw err;
      });
    });
  }

  function toAddItems(items) {
    return items.map(function (it) {
      return { id: Number(it.id != null ? it.id : it.variant_id), quantity: it.quantity, properties: it.properties || {} };
    });
  }

  // items 一括追加は1件でも売切れ(422)だと全件失敗する。まず一括、422なら1件ずつ入れ直して
  // 戻せる分だけ戻す（全滅させて退避データを無限に再試行し続けるのを避ける）。
  function addItemsResilient(items) {
    var list = toAddItems(items);
    if (!list.length) return Promise.resolve(0);
    return cartWrite('/cart/add.js', { items: list })
      .then(function () { return list.length; })
      .catch(function (err) {
        if (!err || err.cartStatus !== 422 || list.length === 1) throw err;
        var added = 0;
        return list.reduce(function (chain, it) {
          return chain.then(function () {
            return cartWrite('/cart/add.js', it).then(function () { added++; }).catch(function () {});
          });
        }, Promise.resolve()).then(function () {
          if (!added) throw err;
          return added;
        });
      });
  }

  function startRaffleEntry(btn) {
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('product-form form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var vid = idEl ? idEl.value : null;
    if (!vid) { window.location.href = '/cart'; return; }
    var props = {};
    if (form) form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
      var m = i.name.match(/^properties\[(.+)\]$/); if (m && i.value !== '') props[m[1]] = i.value;
    });
    if (String(props._raffle) !== 'true') props._raffle = 'true';
    btn.disabled = true; var span = btn.querySelector('span'); var orig = span ? span.textContent : '';
    if (span) span.textContent = '処理中…';

    fetchCart().then(function (cart) {
      var others = (cart.items || []).filter(function (it) { return String((it.properties || {})._raffle) !== 'true'; });
      var parkedItems = others.map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }; });
      if (parkedItems.length) {
        try {
          localStorage.setItem(PARK_KEY, JSON.stringify({ ts: Date.now(), items: parkedItems }));
        } catch (e) {}
      }
      return cartWrite('/cart/clear.js')
        .then(function () {
          return cartWrite('/cart/add.js', { id: Number(vid), quantity: 1, properties: props });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          // 抽選品を追加できなかった（売切れ422・通信断等）。直前に通常カートを空にしているので、
          // 空カートのまま /checkout へ進めず、退避した通常商品をその場で戻す。
          if (!parkedItems.length) throw err;
          return addItemsResilient(parkedItems)
            .then(function () { parkClear(); document.dispatchEvent(new CustomEvent('cart:updated')); })
            .catch(function () {}) // 戻せなければ退避データは残す（次回訪問時に restoreParkedCart が再試行）
            .then(function () { throw err; });
        });
    }).catch(function (err) {
      btn.disabled = false; if (span) span.textContent = orig;
      var detail = (err && err.userMessage) ? '\n' + err.userMessage : '';
      alert('応募手続きを開始できませんでした。' + detail + '\nお手数ですが、もう一度お試しください。');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-raffle-entry]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    startRaffleEntry(btn);
  });

  // 応募後にストアへ戻ってきたら、退避していたカートを復元（24h以内）。
  // 退避データは「復元が成功してから」消す。先に消すと売切れ422・通信断で通常カートを失う。
  // 二重復元は短命ロック(PARK_LOCK_KEY)で防ぐ。
  function restoreParkedCart() {
    var raw; try { raw = localStorage.getItem(PARK_KEY); } catch (e) { return; }
    if (!raw) return;
    var parked; try { parked = JSON.parse(raw); } catch (e) { parkClear(); return; }
    if (!parked || !parked.items || !parked.items.length) { parkClear(); return; }
    if (parked.ts && (Date.now() - parked.ts) > 24 * 3600 * 1000) { parkClear(); return; } // 期限切れは破棄

    var lock = 0;
    try { lock = parseInt(localStorage.getItem(PARK_LOCK_KEY) || '0', 10) || 0; } catch (e) {}
    if (Date.now() - lock < PARK_LOCK_MS) return; // 別タブ/直前の復元が進行中
    try { localStorage.setItem(PARK_LOCK_KEY, String(Date.now())); } catch (e) {}

    // 応募で残った抽選品を含む現カートを一旦クリア → 退避商品を再追加
    cartWrite('/cart/clear.js')
      .then(function () { return addItemsResilient(parked.items); })
      .then(function () {
        parkClear();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        // 失敗時は退避データを残し、ロックだけ解放して次回訪問で再試行させる
        try { localStorage.removeItem(PARK_LOCK_KEY); } catch (e) {}
      });
  }
  document.addEventListener('DOMContentLoaded', restoreParkedCart);
  if (document.readyState !== 'loading') restoreParkedCart();

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

  // テーマ非依存でカート更新を捕捉: /cart/ 書込系 fetch 完了後に refresh。
  // （このテーマは PUB_SUB_EVENTS が module スコープで window 不在のため pub/sub 購読に頼れない）
  var rt = null;
  function scheduleRefresh() { if (rt) return; rt = setTimeout(function () { rt = null; refresh(); }, 200); }
  if (window.fetch && !window.__miyagenRaffleFetchPatched) {
    window.__miyagenRaffleFetchPatched = true;
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { scheduleRefresh(); }).catch(function () {});
      }
      return p;
    };
  }
  // pub/sub があれば併用（保険）
  if (typeof window.subscribe === 'function') {
    ['cart-update', 'cartUpdate', 'cart:update'].forEach(function (k) { try { window.subscribe(k, refresh); } catch (e) {} });
  }

  // variant 切替等でボタンが再描画されても無効化を維持（デバウンス付き MutationObserver）
  var t = null;
  var mo = new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; apply(); }, 120);
  });
  document.addEventListener('DOMContentLoaded', function () {
    var target = document.querySelector('main, #MainContent, body');
    if (target) mo.observe(target, { childList: true, subtree: true });
  });
})();
